import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const LargeTripodBanners = () => {

    const servicesFaqData = [
        {
            question: "What are the benefits of large tripod banners?",
            answer: "Large tripod banners are portable, easy to set up, and ideal for events, trade shows, and promotional campaigns. Their large display area allows for eye-catching custom tripod banner printing that enhances brand visibility and attracts attention."
        },
        {
            question: "What customisation options are available for tripod banners?",
            answer: "Printingy offers extensive customisation for fully customisable tripod banner printing, including sizes, graphics, and finishes. You can add logos, text, and vibrant designs to align with your brand identity."
        },
        {
            question: "Does Printingy handle bulk orders for tripod banners?",
            answer: "Yes, Printingy specialises in bulk tripod banner printing, providing consistent quality and competitive pricing for large-scale orders. Bulk printing is ideal for events, corporate branding, and promotional campaigns."
        },
        {
            question: "What materials are used for large tripod banners?",
            answer: "We use high-quality, lightweight materials such as vinyl and fabric for Large Tripod Banners printing. These materials are durable and tear-resistant, ensuring sharp, vibrant graphics that maintain their professional appearance."
        },
        {
            question: "Are tripod banners reusable?",
            answer: "Our custom tripod banner printing solutions use durable materials and sturdy tripod stands, making them easy to store, transport, and reuse for multiple events or promotions."
        },
        {
            question: "What industries benefit from large tripod banners?",
            answer: "Large tripod banners are widely used across retail, hospitality, education, and events. Businesses use bulk tripod banner printing for trade shows, conferences, and product displays."
        },
        {
            question: "What is the turnaround time for bulk tripod banner printing?",
            answer: "The large Tripod Banner's printing turnaround depends on order size and customisation requirements. Standard bulk orders are completed within a few business days, with clear timelines for larger or urgent projects."
        },
        {
            question: "How can I place an order for custom tripod banners?",
            answer: "To order custom tripod banner printing, visit our website, select your size and customisation preferences, and upload your artwork. Our team will guide you through the design approval and delivery process."
        },
        {
            question: "Are tripod banners suitable for indoor and outdoor use?",
            answer: "Our fully customisable tripod banner printing options are designed for indoor and light outdoor use. Materials are fade-resistant and sturdy, ensuring professional results in any setting."
        },
        {
            question: "What makes bulk tripod banner printing cost-effective?",
            answer: "Bulk tripod banner printing reduces per-unit costs, making it ideal for businesses needing multiple banners for events or promotions. Printingy ensures consistent quality and competitive pricing across large-scale orders."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Large Tripod Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Large Tripod Banners Printing Services"
  description="Professional printing of large tripod banners for events and promotions. Bulk custom tripod banner printing and fully customisable tripod banner solutions."
  keywords="Indoor Banners,
Indoor Banners Printing,
Flex Printing Design Indoor,
Interior Design Printing,
Printing for Indoor Banners,
Custom Banners Printing Indoor"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Large Tripod Banners</h1>
              <h2 className="text-muted">Fully customisable tripod banners for events, branding, and promotions</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Large tripod banners are ideal for impactful displays at events, trade shows, and corporate branding. Printingy specialises in Large Tripod banner printing, providing high-quality, durable, and visually striking solutions tailored to your needs.</p>
          <p>Our services include Custom Tripod Banners Printing for personalised designs, logos, and messaging. With bulk tripod banner printing options, we ensure cost-effective, consistent, and professional results for large-scale requirements.</p>
          <p>From promotional campaigns to product showcases, Printingy’s fully customisable tripod banner printing solutions deliver sharp visuals and sturdy structures that enhance your brand’s visibility and appeal.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Tripod Banner Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and fully customisable tripod banners</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Large Tripod Banner printing for impactful displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom tripod banner printing for large-scale promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customisable tripod banner printing to meet branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight yet durable materials with sturdy tripod stands.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for sharp, vibrant graphics.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Easy to assemble, transport, and reuse for multiple events.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and urgent orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by event organisers, businesses, and exhibitors nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/tripodbanners.jpg" // Path relative to the public folder
                  alt="Interior design printing for indoor displays"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Large Tripod Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your event while we handle your tripod banner printing needs</h3>
            <p>At Printingy, we combine premium materials and advanced printing technology to deliver exceptional Large Tripod Banners printing services. Whether you need fully customisable banner printing for conferences or bulk tripod banner printing for promotional events, we ensure durability and professionalism in every order.</p>
            <p>Our streamlined production process guarantees quick turnarounds without compromising quality, so your banners are ready for display when you need them. Partner with Printingy to create visually striking tripod banners that elevate your brand’s impact.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default LargeTripodBanners;
